/**
 * * @module component/tablet-carousel.js
 */
import regeneratorRuntime from "regenerator-runtime";
import backbone from "backbone";
import $ from "jquery";
import _ from "underscore";
import Bootstrap from "bootstrap";
import owlCarousel from "owl.carousel";

const MobileAndTabletCarousel = Backbone.View.extend({

  initialize: function () {
    this.render();
  },

  mobileAndTabletOnlyCarousel: function() {
    var _this = this;

    var owl = $(".mobile-tablet-carousel"),
      owlOptions = {
        margin: 10,
        loop: false,
        touchDrag: true,
        items: 1,
        dots: false,
        nav: true,
        navText: [
          "<span class='icon icon-arrow-left'></span>",
          "<span class='icon icon-arrow-right'></span>",
        ],
        responsive: {
          768: {
            items: 2,
          }
        },
      };

    if ($(window).width() <= 768) {
      var owlActive = owl.owlCarousel(owlOptions);
    } else {
      owl.addClass("off");
    }

    $(window).resize(function () {
      if ($(window).width() <= 768) {
        if ($("mobile-tablet-carousel").hasClass("off")) {
          var owlActive = owl.owlCarousel(owlOptions);
          owl.removeClass("off");
        }
      } else {
        if (!$("mobile-tablet-carousel").hasClass("off")) {
          owl.addClass("off").trigger("destroy.owl.carousel");
          owl.find(".owl-stage-outer").children(":eq(0)").unwrap();
        }
      }
    });
    
  },

  render: function () {
    this.mobileAndTabletOnlyCarousel();
  }


});

export default MobileAndTabletCarousel;